const log = {
    invalid_type: 'نوع گزارش نامعتبر است.',
    invalid_time_window: '`end_time` باید بعد از `start_time` باشد.',
};
export default Object.freeze(log);
